import pythonDateFormatToJs from 'src/utils/pythonDateFormatToJs';
import { formatDateService } from 'src/services';
import { useFormBuilderStore } from 'src/store/main';

import { createApp } from 'vue';
import App from 'src/App.vue';
import { createPinia } from 'pinia';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

export default class DateInputClass {
  constructor() {
    // if needed
  }

  getMask(format = '') {
    try {
      return String(
        pythonDateFormatToJs.methods.convertPYDateFormatToMask(format),
      );
    } catch (err) {
      logError(err);
      return '';
    }
  }

  getFormat(format = '') {
    try {
      return String(
        pythonDateFormatToJs.methods.convertPYDateFormatToJS(format),
      );
    } catch (err) {
      logError(err);
      return '';
    }
  }

  async format(value = '') {
    try {
      const form_builder_store = useFormBuilderStore();
      const pattern = form_builder_store.getDocDateFormat();
      const locale = form_builder_store.getDocLocale();

      // A valid date must have at least 6 chars (e.g. "1.1.24")
      if (!value || !pattern || value.length < 6) {
        return '';
      }

      const response = await formatDateService.format(value, locale, pattern);
      if (response.data.success === false) {
        return '';
      }
      return String(response.data.formatted_value);
    } catch (err) {
      logError(err);
      return '';
    }
  }

  // handleDateFieldMask (format: string) {
  //     const doc_store = useDocumentStore();
  //     // pythonDateFormatToJs.methods.convertPYDateFormatToJS
  //     return
  // }
}
